<div class="diary-card-wrapper" [class.comment]="showComment">
  <div class="card-header-wrapper" *ngIf="type || timestamp">
    <div *ngIf="diaryType" class="notebook-type-wrapper">
      <img *ngIf="diaryUtils.getIcon(this.diaryType!)" class="notebook-type-icon" height="14px" width="14px"
        [src]="diaryUtils.getIcon(this.diaryType!)" alt="icon"/>
      <h5 class="notebook-type-name">{{diaryType.label}}</h5>
    </div>
    <div *ngIf="type && !diaryType" class="notebook-type-wrapper">
      <img *ngIf="diaryUtils.getLegacyIcon(this.type!)" class="notebook-type-icon" height="14px" width="14px"
           [src]="diaryUtils.getLegacyIcon(this.type!)" alt="icon"/>
      <h5 class="notebook-type-name">{{diaryUtils.getLegacyLabel(type!)}}</h5>
    </div>

    <h5 class="notebook-date" *ngIf="timestamp">{{date}}</h5>
  </div>

  <div class="pictures-slideshow" *ngIf="pictures && pictures.length > 0">
    <carousel [isAnimated]="true" [interval]="0">
      <slide (click)="showPicture(i)" *ngFor="let picture of pictures; let i = index">
        <img [src]="picture" class="dish-preview-image" alt="picture">
      </slide>
    </carousel>
  </div>

  <h3 class="notebook-name" *ngIf="name && name.length > 0">{{name}}</h3>

  <div class="trackers-wrapper" *ngIf="trackers && trackers.length > 0">
    <div class="cursor" *ngFor="let cursor of trackers">
      <span class="cursor-label">{{cursor.name}}</span>
      <span class="cursor-value">{{cursor.value | number : '1.0'}}</span>
    </div>
  </div>

  <div class="comment-button" tooltip="Ce commentaire est privé, il ne sera pas visible par le patient" placement="top"
    (click)="showCommentInput()">
    <i i-bs name="pencil" width="14" height="14"></i>
  </div>

  <div class="comment-textarea-wrapper">
    <textarea *ngIf="showComment" #diaryCommentTextarea (keydown.enter)="$event.preventDefault()" [minRows]="1"
      [maxRows]="3" [(ngModel)]="editedComment" autosize [placeholder]="'Commentaire privé...'" type="text"
      class="form-control comment-textarea" aria-describedby="content"></textarea>
    <div class="comment-loading" *ngIf="isCommentLoading">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      <span class="visually-hidden">Chargement...</span>
    </div>
  </div>

</div>

<msd-diary-picture-preview-modal [selectedIndex]="selectedIndex" [pictures]="pictures" [show]="previewVisible"
  (close)="closePreview()"></msd-diary-picture-preview-modal>
